import { IFSMMachine } from '@src/slide/infrastructure/module/independent/state-machine/state-machine.interface';

export const BOOT_STATE_TYPE = {
    notInit: 'notInit',                                     // 未启动
    init: 'init',                                           // 启动
    infrastructureDidReady: 'infrastructureDidReady',       // 基础设施完成
    firstSlideDidRender: 'firstSlideDidRender',             // 首页Slide内容渲染完成
    firstScreenDidLoad: 'firstScreenDidLoad',               // 首屏的内容渲染完成，PC端对接为所有页面渲染完成
};


export const TRANSITION_EVENT_TYPE = {
    didInitEvent: 'didInitEvent',
    infrastructureDidReadyEvent: 'infrastructureDidReadyEvent',
    firstSlideDidRenderEvent: 'firstSlideDidRenderEvent',
    firstScreenDidLoadEvent: 'firstScreenDidLoadEvent',
};

export interface IBootManager {
    bootStateMachine: IFSMMachine;
}
